import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PreviewPdfService } from '@shared/services/preview-pdf.service';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { confirm, custom, alert } from 'devextreme/ui/dialog';
import { Auth, Hub } from 'aws-amplify';
import { ConfirmationPopupOption } from '../confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-preview-pdf',
  templateUrl: './preview-pdf.component.html',
  styleUrls: ['./preview-pdf.component.less']
})
export class PreviewPdfComponent implements OnInit {

  @ViewChild(PdfViewerComponent) pdfViewer: PdfViewerComponent;

  pdfUrl:string|any;
  fileName="MPG";
  iframe = document.createElement('iframe');

  // directDownload:boolean=true;
  // showPdf:boolean=false;

  openConfirmationPopup:boolean=false;
  confirmationPopupOption:ConfirmationPopupOption={
    visible: true,
    message: 'Check your browser pdf preference setting or else try downloading pdf',
    confirmButtonText: '',
    rejectButtonText: 'OK',
    normalButtonText: '',
    showCloseButtn: false,
    option: 'preview-pdf-print-block'
  };
  

  constructor(private _preview: PreviewPdfService, private route: ActivatedRoute, private sanitizer : DomSanitizer) {
    let idStr = this.route.snapshot.paramMap.get('id');

    document.body.appendChild(this.iframe);
    this.iframe.style.display = 'none';
    
    
    let id:number|null=null;
    if(idStr)
      id=Number(idStr);
    if(id!=null){
      let temp = window.localStorage.getItem("pdfPayload");
      if(temp){
          let payloadList=JSON.parse(temp);
          if(payloadList && id<payloadList?.length){
            this.fileName=payloadList[id].fileName;

            _preview.getPdf(payloadList[id]).subscribe(
              r=>{
                if(id!=null && payloadList[id].checkResponseForFileName){
                  this.fileName = r.headers.get('filename');
                  if(this.fileName.endsWith(".pdf")){
                    this.fileName = this.fileName.split('.')[0];
                  }else{
                    this.customAlert(this.fileName);
                    return
                  }
               }
                let blob:Blob = r.body as Blob;
                this.pdfUrl = window.URL.createObjectURL(blob);
                // this.pdfUrl = this.getSanitizedURL(window.URL.createObjectURL(blob));
                this.iframe.src = this.pdfUrl;
              },
              e=>{
                if(id && payloadList[id].checkResponseForFileName)
                  this.customAlert(e);
                else
                  window.alert("something went wrong");
              }
          );
        }
        else{
          window.alert("Something went wrong");
        }
      }
      else{
        window.alert("Something went wrong");
      }
      
    }
    else{
      window.alert("Something went wrong");
    }


    this.printPdf = this.printPdf.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);

  }

  ngOnInit(): void {
  }

  // getSanitizedURL(url:any) {
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  // }

  @HostListener('window:keydown.control.p', ['$event'])
  preventPrint(event: KeyboardEvent) {
    event.preventDefault();
  }

  @HostListener('window:keydown',['$event'])
  onKeyPress($event: KeyboardEvent) {
    if(($event.ctrlKey || $event.metaKey) && ($event.key == 'p' || $event.key == 'P'))
      this.printPdf();
  }

  downloadPdf(){
    const a = document.createElement('a');
    a.href = this.pdfUrl;
    a.download = this.fileName + '.pdf';
    a.click();
    a.remove();
  }


  printPdf(){
    try {
      this.iframe.contentWindow?.print();
    } catch (e:any) {
      if(e.toString().includes('Blocked a frame with origin'))
        this.openConfirmationPopup=true;
    }
  }

  ngOnDestroy() {
    window.localStorage.removeItem("pdfPayload");
    window.URL.revokeObjectURL(this.pdfUrl);
    document.body.removeChild(this.iframe);
  }

  customAlert(message:any){
    const mpDialog = custom({
      showTitle: false,
      messageHtml: message,
      buttons: [
        {
          text: "Signout and Close",
          onClick: (e) => {
            window.localStorage.removeItem("mp-serve-auth");
          window.localStorage.removeItem("mpuserdetailslock");
          window.localStorage.removeItem("mpUInfo");
          window.localStorage.removeItem('cookieDetails');
          window.localStorage.removeItem('cookieStartTimer');
          window.localStorage.removeItem('cookieEndTimer');
            Auth.signOut();
          }
        }
      ]
    });

    mpDialog.show().then((dialogResult:any) => {});
  }

}
